import { ZCDLineChart } from '@zencity/common-ui';
import { ZCDLineChartData } from '@zencity/common-ui/lib/ZCD/ZCDCharts/ZCDLineChart/helpers/ZCDLineChart.constants';
import { ScoreOverTimeByAreaContext } from 'contexts/ScoresOverTimeByAreaContext';
import React, { ReactElement, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { getLineChartQuarterOrMonthLabel } from 'screens/WidgetGenerator/reportGeneratorComponents/components/ScoresOverTimeByArea/ScoresList/ScoreRow/AspectScoresLineChart/AspectScoresLineChart.helpers';
import { Header } from 'screens/WidgetGenerator/reportGeneratorComponents/components/ScoresOverTimeByArea/ScoresList/ScoreRow/AspectScoresLineChart/Header/Header';
import styles from './AspectScoresLineChart.module.scss';

const MAX_LINE_CHART_DATA_POINTS = 6;
const MIN_LINE_CHART_DATA_POINTS = 2;
const PARENT_DIVISION_DATA_LABEL = 'parent-division-data';

export const AspectScoresLineChart = (): ReactElement => {
  const { t: translate } = useTranslation();
  const { allAspectScoresWithDateRange, parentDivisionAspectScoresWithDateRange } =
    useContext(ScoreOverTimeByAreaContext);
  const lineChartLabels = allAspectScoresWithDateRange
    .map((aspectScore) => getLineChartQuarterOrMonthLabel(aspectScore.startDate, aspectScore.endDate))
    .slice(-MAX_LINE_CHART_DATA_POINTS);
  const lineChartData = allAspectScoresWithDateRange
    .map((aspectScore) => Math.round(aspectScore.overallAspectScore))
    .slice(-MAX_LINE_CHART_DATA_POINTS);
  const parentDivisionLineChartData = parentDivisionAspectScoresWithDateRange
    .map((parentAspectScore) => Math.round(parentAspectScore.overallAspectScore))
    .slice(-MAX_LINE_CHART_DATA_POINTS);

  const chartData: ZCDLineChartData = {
    labels: [],
    datasets: [],
  };
  const displayEmptyChart = lineChartData.length < MIN_LINE_CHART_DATA_POINTS;
  if (!displayEmptyChart) {
    chartData.labels = lineChartLabels;
    chartData.datasets.push({
      // eslint-disable-next-line id-denylist
      data: lineChartData,
      label: translate('widgetGenerator.widgets.scoresOverTimeByArea.lineChart.datasetLabel'),
    });
  }
  if (parentDivisionLineChartData.length) {
    chartData.datasets.push({
      // eslint-disable-next-line id-denylist
      data: parentDivisionLineChartData,
      label: PARENT_DIVISION_DATA_LABEL,
      segment: {
        borderDash: [4, 4],
      },
      borderWidth: 1,
      pointStyle: false,
      pointRadius: 0,
      pointHoverRadius: 0,
      pointHitRadius: 0,
      datalabels: {
        display: false,
      },
    });
  }

  return (
    <section>
      <Header />
      <div className={styles.chartContainer}>
        <ZCDLineChart chartData={chartData} includeLegend={false} />
      </div>
    </section>
  );
};
